import React from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Divider,
  Tabs,
  Button,
  TabsProps,
} from "antd";
import { InvestmentAcrossSector } from "../../Components/InvestmentAcrossSector/InvestmentAcrossSector";
import AsiaMap from "../../Components/Map/Map";
import { Title } from "../Title/Title";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

export const DecarbProjects = () => {
  const navigate = useNavigate();
  return (
    <>
      <div>
        <div style={{ paddingLeft: 0 }}>
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            <Typography.Text className="textSmall" style={{ color: "#fff" }}>
              A hub to support and engage investors and infra owners/developers
              across sectors to access impact funds digitally.
            </Typography.Text>
          </div>
          <div style={{ paddingBottom: 10, display: "flex" }}>
            <Button
              type="primary"
              style={{ height: 32 }}
              className="btn-primary"
              onClick={() => navigate("/investment-hub")}
            >
              Explore&nbsp; <Icon icon="akar-icons:arrow-right" />
            </Button>

            <Button
              type="primary"
              style={{ height: 32, marginLeft: 20 }}
              className="btn-primary"
              onClick={() => navigate("/investment-hub/new-project")}
            >
              <Icon style={{ fontSize: 18 }} icon="material-symbols:add" />
              &nbsp;New Project
            </Button>
          </div>
        </div>
        <div>
          <InvestmentAcrossSector />
          <AsiaMap />
        </div>
      </div>
    </>
  );
};
